<ng-container *ngIf="payroll && payline">
  <div class="d-flex">
    <h1 class="page-title mb-2 me-auto">Run Correction Payroll</h1>
    <div>
      <button class="btn btn-secondary me-3" (click)="back()">Back</button>
      <button class="btn btn-primary" (click)="continue()">Confirm & Continue</button>
    </div>
  </div>
  <div class="mb-4">
    <span class="me-4"> Pay Date: {{ payroll.PayDate | date: 'MM/dd/yyyy' }} </span>
    <span> Net Amount: {{ payline.NetAmountPaid | currency }} </span>
  </div>
  <payline-detail-editor
    *ngIf="render"
    [args]="paylineDetailArgs"
    [payroll]="payroll"
    [startData]="startData"
    [earningConfigs]="earningConfigs"
    [deductionConfigs]="deductionConfigs"
    [taxConfigs]="taxConfigs"
    [employeePay]="employeePay">
  </payline-detail-editor>
</ng-container>
